import { AxiosResponse } from 'axios'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import { IValePedagioRepository } from '../../domain/repositories/IValePedagioRepository'
import IDetalhesViagemPedagioDTO from '../../domain/entities/IDetalhesViagemPedagioDTO'
import IViagemPedagioDTO from '../../domain/entities/IViagemPedagioDTO'
import { IFiltroViagens } from 'modules/valePedagio/domain/usecases/FindViagensComVPO'

const http = new ServiceConfig()
export default class ValePedagioRepository implements IValePedagioRepository {
  public async findViagensComVPOMotorista(
    documento: string,
    filtro: IFiltroViagens,
  ): Promise<IViagemPedagioDTO[]> {
    let query = `/vale-pedagio/viagens?documento=${documento}`

    if (filtro?.cte) query += `&cte=${filtro.cte}`

    if (filtro?.placa) query += `&placa=${filtro.placa}`

    const response: AxiosResponse<IViagemPedagioDTO[]> = await http.get(query)
    return response.data
  }

  public async findDetalhesViagemComVPO(
    id: number,
    documento: string,
  ): Promise<IDetalhesViagemPedagioDTO> {
    const query = `/vale-pedagio/detalhes-viagem?id=${id}&documento=${documento}`
    const response: AxiosResponse<IDetalhesViagemPedagioDTO> = await http.get(
      query,
    )
    return response.data
  }
}
